import { Component, OnInit } from '@angular/core';
import {CardModule} from 'primeng/card';
import { Title, Meta } from '@angular/platform-browser';

@Component({
  selector: 'app-kontakt',
  templateUrl: './kontakt.component.html',
  styleUrls: ['./kontakt.component.css']
})
export class KontaktComponent implements OnInit {
  address: string;
  phone: string;
  name: string;
  emailAdd: string;

  constructor(private titleService: Title,
    private metaTagService: Meta) { }

  ngOnInit() {
    this.address='Fintická 97, Prešov 08006';
    this.phone='0905 384 799';
    this.name="Peter Krišanda";
    this.emailAdd="peter.krisandadsi@gmail.com";
    this.titleService.setTitle("Stolárstvo-Krisanda: Kontaktujete nas");
    this.metaTagService.updateTag({name: 'description', content: "Kontakt na stolarstvo krisanda v Presove. Nabytok na mieru."});
  }
}
